import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/admin/users')({
  staticData: {
    title: 'route.admin.users',
    crumb: 'route.admin.users',
    permissions: ['users_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
